import React, { useState } from "react";

const basePlaceholder = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#f0f0f0",
  color: "#8c8c8c",
  fontSize: 11,
  textAlign: "center",
  boxSizing: "border-box",
};

/**
 * Thumbnail for staff-only /features demo data. On load error, shows a local
 * placeholder (no third-party URLs — avoids blocked hosts and request spam).
 */
export function DemoImage({ src, alt = "", style = {} }) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <span
        role="img"
        aria-label={alt || "No image"}
        style={{ ...basePlaceholder, ...style }}
      >
        No image
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      style={style}
      onError={() => setFailed(true)}
    />
  );
}
